
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M6.263 6.01a2.3 2.3 0 0 1 2.561-1.503 2.3 2.3 0 0 1 1.913 2.27C10.737 8.308 8.5 9 8.5 9v1m.5 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m6.5-4a7 7 0 1 1-14 0 7 7 0 0 1 14 0"}})])
          )
        }
      }
    